/**
 * The practices eMerge covers at a building, for Scheduling (migration 20261104f; Isaiah Cotto, 2026-11-04), as chips
 * beside the building's name on the board, the Kanban card and the Facility table. A building with no practice
 * recorded reads as Audiology (the platform's original practice): that chip is dashed and says it is the default.
 * These chips are Scheduling's coverage, not the clinical gate: a Podiatry chip does not mean Podiatry charting is
 * open at the building. Nothing here names a resident.
 */
import React from 'react';
import { PRACTICE_CODES, PRACTICE_LABEL, practiceWords } from './buildingsApi';

export const IMPLIED_TITLE = 'Audiology: the default for a building with no practice recorded in eMerge.';

export default function PracticeChips({ practices, implied }: { practices?: readonly string[] | null; implied?: boolean }) {
  // An older server sends no practices: nothing is shown, never a guess.
  if (!practices) return null;
  const list = PRACTICE_CODES.filter((c) => practices.includes(c));
  if (!list.length) return <span className="sc-practices um-quiet">No practice recorded</span>;
  return (
    <span className="sc-practices" role="list" aria-label={`Practices: ${practiceWords(list)}${implied ? ' (the default)' : ''}`}>
      {list.map((c) => (
        <span key={c} role="listitem" className={`sc-tag sc-practice${implied ? ' implied' : ''}`} title={implied ? IMPLIED_TITLE : undefined}>
          {PRACTICE_LABEL[c]}
        </span>
      ))}
    </span>
  );
}
